import React, { useState } from "react";
import faqImg from '../assets/img/faq2.jpg'

const faqs = [
  {
    question: "What does Oethical Technology do?",
    answer:
      "At Oethical Technology, we are committed to helping businesses of all sizes and industries achieve their technology goals. We specialize in providing comprehensive IT solutions that are tailored to meet the unique needs of each client.",
    aosDelay: 200,
  },
  {
    question: "How can I get in touch with Oethical Technology?",
    answer:
      "You can contact Oethical Technology through our website’s contact form, by email at oethicaltechnology@gmail.com, or by phone at (+91) 9532912517. We’re here to help with any inquiries you may have.",
    aosDelay: 300,
  },
  {
    question: "Where is Oethical Technology located?",
    answer:
      "Oethical Technology is based in [Bhopal Madhay Pradesh, India]. We also offer remote consultations and services to clients worldwide. For more details on our location, please visit our website’s contact page.",
    aosDelay: 400,
  },
  {
    question: "What is EduAdminHub?",
    answer:
      "EduAdminHub is an all-in-one school management platform designed to make everyday tasks simple and efficient. It helps schools and colleges manage everything — from student and staff registration to fee collection, student monitoring, and role-based dashboards — all in one easy-to-use system.",
    aosDelay: 400,
  },
  {
    question: "How can I learn more about EduAdminHub?",
    answer:
      "To learn more about EduAdminHub, go to the Products tab at the top of the page and click on EduAdminHub. You can also book a demo by clicking the Schedule Demo button, or contact us anytime through the Contact Us page.",
    aosDelay: 400,
  },
];

const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  //================= Main_retun_function ===============//
  return (
    <section id="faq" className="faq section font-[poppins]">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-7 d-flex flex-column justify-content-center order-2 order-lg-1">
            <div
              className="content px-xl-5"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h3 className="font-[poppins] !font-bold !text-[24px] md:!text-[34px]">
                <span>Frequently Asked </span>
                <span className="font-[Playfair] ml-1 italic text-[#9bd66c]">
                  Questions
                </span>
              </h3>
              <div className=" w-14 h-1 bg-[#9bd66c] mb-2"></div>
              <p>
                At Oethical Technology, we’re committed to delivering innovative
                IT solutions that help businesses of all sizes succeed. Our team
                collaborates closely with you to understand your unique needs
                and provide technology strategies that drive real results.
              </p>
            </div>

            <div
              className="faq-container px-xl-5 "
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {faqs.map((faq, index) => (
                <div
                  className={`faq-item ${
                    activeIndex === index ? "faq-active" : ""
                  } cursor-pointer`}
                  key={index}
                  onClick={() => handleToggle(index)}
                >
                  <i className="faq-icon bi bi-question-circle"></i>
                  <h3>{faq.question}</h3>
                  <div
                    className={`faq-content ${
                      activeIndex === index ? "show" : ""
                    }`}
                  >
                    <p>{faq.answer}</p>
                  </div>
                  <i
                    className={`faq-toggle bi ${
                      activeIndex === index
                        ? "bi-chevron-down"
                        : "bi-chevron-right"
                    }`}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-5 order-1 flex justify-center items-center order-lg-2">
            <img
              src={faqImg}
              className="img-fluid"
              alt="faq"
              data-aos="zoom-in"
              data-aos-delay="100"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
